/// <reference path="../../../Scalesoft.Shared.FrontEnd/Scripts/Window.d.ts" />

import Tooltip from "bootstrap/js/dist/tooltip";

declare const basePath: string;

export default class LocalizationInitializer {
    private languageSelector = jq(".language-select");
    private readonly langDropdown: HTMLElement = document.querySelector(".lang-dropdown");

    private readonly clickHandler: (clickEvent: JQuery.ClickEvent) => void;

    constructor() {
        this.clickHandler = (event) => {
            const clickedBtn = jq(event.currentTarget);
            const selectedCulture = clickedBtn.attr("data-lang-value");
            const selectLanguageForm = jq("#request-culture-form");
            selectLanguageForm.children("#culture").val(selectedCulture);
            selectLanguageForm.trigger("submit");
        };
    }

    private tooltipInit(element: HTMLElement): Tooltip | null {
        if (element === null) {
            return null;
        }
        return new Tooltip(element);
    }

    public init(): void {
        this.tooltipInit(this.langDropdown);

        window.localization = new Localization({
            siteUrl: basePath,
            errorResolution: LocalizationErrorResolution.Key,
            onError: (localizationError) => {
                // Show a nice user friendly error message
                // tslint:disable-next-line:no-console
                console.error(localizationError);
            },
        });

        this.languageSelector.find("button").on("click", this.clickHandler);
    }

    public reinit(): void {
        this.tooltipInit(this.langDropdown);

        this.languageSelector.find("button").off("click", this.clickHandler);
        this.languageSelector = jq(".language-select");
        this.languageSelector.find("button").on("click", this.clickHandler);
    }
}
